import i18next from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import en from '../locales/en/translation.json';

export const supportedLanguages = {
  en: 'English',
};

export const defaultLanguage = 'en';

const languageDetectorOptions = {
  order: ['localStorage', 'navigator', 'htmlTag'],
  caches: ['localStorage'],
  lookupLocalStorage: 'i18nextLng',
};

const savedLanguage = (typeof window !== 'undefined' && localStorage.getItem('i18nextLng')) || defaultLanguage;

i18next
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: savedLanguage,
    fallbackLng: defaultLanguage,
    resources: {
      en: {
        translation: en,
      },
    },
    detection: languageDetectorOptions,
    interpolation: {
      escapeValue: false,
      skipOnVariables: false,
    },
    debug: false,
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
    defaultNS: 'translation',
    ns: ['translation'],
    react: {
      useSuspense: false,
    },
    load: 'languageOnly',
    preload: [defaultLanguage],

  });

const updateHtmlLang = (language: string) => document.documentElement.setAttribute('lang', language);

updateHtmlLang(i18next.resolvedLanguage ?? i18next.language);

i18next.on('languageChanged', updateHtmlLang);

export const changeLanguage = async (language: string) => {
  try {
    await i18next.changeLanguage(language);
    if (typeof window !== 'undefined') {
      localStorage.setItem('i18nextLng', language);
    }
    return true;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to change language:', error);
    return false;
  }
};

export const getCurrentLanguage = () => (i18next.language) || defaultLanguage;
export const isLanguageSupported = (language: string) => language in supportedLanguages;

export default i18next;
